import { toEuros, toHours } from "@/utils/numberUtils";
import { Transform } from "class-transformer";

export class CalculatePayrollResultDto {
  workedDays: number;

  workingDays: number;

  @Transform(({ value }) => toHours(value))
  workableMinutes: number;

  @Transform(({ value }) => toHours(value))
  totalValidatedMinutes: number;

  @Transform(({ value }) => toHours(value))
  holidayOvertimeMinutes: number;

  @Transform(({ value }) => toEuros(value))
  holidayOvertimeAmount: number;

  @Transform(({ value }) => toHours(value))
  workableOvertimeMinutes: number;

  @Transform(({ value }) => toEuros(value))
  workableOvertimeAmount: number;

  @Transform(({ value }) => Number(value ?? 0) / 100)
  pointsQuantity: number;

  pointsQuantityScale: number;

  @Transform(({ value }) => toEuros(value))
  pointsAmount: number;
}
